/* eslint-disable camelcase */
import store from '../store';
/** Will overwrite previously created LocalEntity.  Note that any existing data in that LocalEntity will be lost */
export default function registerVuexModule_overrideExisting(moduleName, module) {
    const localEntityExists = store.hasModule(moduleName);
    if (localEntityExists)
        store.unregisterModule(moduleName); // this only works for dynamically registered modules: https://vuex.vuejs.org/guide/modules.html#dynamic-module-registration
    store.registerModule(moduleName, module);
}
